<template lang="pug">
  .pt-2
    .h5.text-primary.mt-2 {{ 'assunto.informacoes' | tModel }}
    div(v-for='item, i in list')
      item(
        :item='item'
        :editing='item === itemEditing'
        :index='i'
        @toedit='toEdit'
        @save='onSaveItem'
        @destroy='onDestroy'
      )
    .card.mb-2
      .card-body.text-right
        a.btn.btn-action.s-circle.tooltip(@click='add' data-tooltip='Novo item')
          i.icon.icon-plus
</template>

<script>
import AssuntoInformacao from '@/models/AssuntoInformacao'
import Item from './Item'

export default {
  props: {
    items: { type: Array, required: true },
  },

  components: { Item },

  data() {
    return {
      itemEditing: null,
    }
  },

  computed: {
    list() {
      return this.items.filter(item => !item._destroy)
    },
  },

  methods: {
    toEdit(item) {
      this.itemEditing = item
    },

    onSaveItem(item) {
      this.itemEditing = null
    },

    onDestroy(item, index) {
      if (item.id) {
        this.$set(item, '_destroy', true)
      } else {
        this.$delete(this.items, index)
      }
    },

    add() {
      this.itemEditing = new AssuntoInformacao()
      this.items.push(this.itemEditing)
    },
  },
}
</script>
